module.exports = __webpack_public_path__ + "img/addr_img.23a201bd.png";